import ScenarioActionType from '@/store/modules/scenario/scenario.type'
import { CardService } from '@/services/bot.service'

const types = ScenarioActionType

const CardStoreMixin = {
    [types.CREATE_CARD] (context, data) {
        let state = context.state
        context.commit(types.ADD_SAVING_COUNT, 1)
        let step = state.mapCodeToStep[data.step_code]
        let scenario = state.mapCodeToScenario[step.scenario_code]
        if (typeof data.config === 'object') {
            data.config = JSON.stringify(data.config)
        }
        return CardService.create(scenario.app_code, scenario.code, step.code, data).then(
            result => {
                let card = result.data
                card.config = JSON.parse(card.config)
                state.cardList.push(card)
                state.mapCodeToCard[card.code] = card
                let step = state.mapCodeToStep[card.step_code]
                let cardList = step.cards
                if (typeof data.position === 'number') {
                    cardList.splice(data.position, 0, card)
                    cardList.forEach((card, i) => {
                        card.position = i
                    })
                    context.dispatch(ScenarioActionType.POSITION_CARD, {
                        botCode: scenario.app_code,
                        scenarioCode: scenario.code,
                        stepCode: step.code,
                        cardCodeList: cardList.map(card => card.code)
                    })
                } else {
                    cardList.push(card)
                }
                context.commit(types.ACTIVE_DATA, {
                    activeCardCode: card.code
                })
                return card
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.UPDATE_CARD] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let card = context.state.mapCodeToCard[data.code]
        if (data.config) {
            data.config = JSON.stringify(data.config)
        } else {
            data.config = JSON.stringify(card.config)
        }
        data.card_type_id = card.card_type_id
        let step = context.state.mapCodeToStep[card.step_code]
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        return CardService.update(
            scenario.app_code,
            scenario.code,
            step.code,
            data.code,
            data
        ).then(
            result => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                let newCard = result.data
                let oldCard = context.state.mapCodeToCard[data.code]
                Object.assign(oldCard, newCard)
                oldCard.config = JSON.parse(oldCard.config)
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return oldCard
            },
            e => {
                context.commit(types.ADD_SAVING_COUNT, -1)
                return Promise.reject(e)
            }
        )
    },
    [types.DELETE_CARD] (context, card) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let step = context.state.mapCodeToStep[card.step_code]
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        return CardService.delete(
            scenario.app_code,
            scenario.code,
            step.code,
            card.code
        ).then(
            result => {
                context.state.cardList.splice(
                    context.state.cardList.indexOf(card),
                    1
                )
                step.cards.splice(
                    step.cards.indexOf(card),
                    1
                )
                context.state.mapCodeToCard[card.code] = null
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return result.data
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.POSITION_CARD] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let stepCode = data.stepCode
        let step = context.state.mapCodeToStep[stepCode]
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        return CardService.updatePosition(
            scenario.app_code,
            scenario.code,
            stepCode,
            data.cardCodeList
        ).then(
            result => {
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return result.data
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    },
    [types.UPDATE_CARD_CONDITION] (context, data) {
        context.commit(types.ADD_SAVING_COUNT, 1)
        let card = context.state.mapCodeToCard[data.code]
        let step = context.state.mapCodeToStep[card.step_code]
        let scenario = context.state.mapCodeToScenario[step.scenario_code]
        return CardService.update(
            scenario.app_code,
            scenario.code,
            step.code,
            card.code,
            {
                card_type_id: card.card_type_id,
                config: JSON.stringify({
                    ...card.config,
                    conditions: data.conditions

                })
            }
        ).then(
            result => {
                let newCard = result.data
                let oldCard = context.state.mapCodeToCard[newCard.code]
                newCard.config = JSON.parse(newCard.config)
                oldCard.config.conditions = newCard.config.conditions
                context.dispatch(types.SHOULD_UPDATE_GRAPH)
                return oldCard
            }
        ).finally(() => {
            context.commit(types.ADD_SAVING_COUNT, -1)
        })
    }
}

export default CardStoreMixin
